import { render, staticRenderFns } from "./proposalsPrioritization.vue?vue&type=template&id=1aaf1c64&scoped=true&"
import script from "./proposalsPrioritization.vue?vue&type=script&lang=ts&"
export * from "./proposalsPrioritization.vue?vue&type=script&lang=ts&"
import style0 from "./proposalsPrioritization.vue?vue&type=style&index=0&id=1aaf1c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaf1c64",
  null
  
)

export default component.exports